import { render } from "./DocumentDetailsInformations.vue?vue&type=template&id=94a940b0&ts=true"
import script from "./DocumentDetailsInformations.vue?vue&type=script&lang=ts"
export * from "./DocumentDetailsInformations.vue?vue&type=script&lang=ts"

import "./DocumentDetailsInformations.vue?vue&type=style&index=0&id=94a940b0&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__